import { BasicTrackingEvent } from "./BasicTrackingEvent";

export class ShopCheckoutTrackingEvent extends BasicTrackingEvent {
    public date: number;
    public sessionId: string;
    public microtime: string;
    public orderId: number;
    public deviceId: number;
    public price: string;
    public playerId: number;

    public shopId: number = 1;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        let vars: any = {};

        vars.playerId = this.playerId;
        vars.date = this.date;
        vars.var_1 = this.sessionId;
        vars.var_2 = this.microtime;
        vars.var_3 = this.shopId;
        vars.var_4 = this.orderId;
        vars.var_5 = "";
        vars.var_6 = this.deviceId;
        vars.var_7 = this.price;

        return vars;
    }
}
